import React, { useState, Fragment } from "react";
import icEthizo from "../../../assets/images/ic-ethizo.svg";
import icScreen from "../../../assets/images/ic-screen.svg";
import icPlaceholder from "../../../assets/images/ic-placeholder.svg";
import icPractice from "../../../assets/images/practiceIcon.svg";
import IcMenu from "../../../assets/images/ic-menu.svg";
import identification from "../../../assets/images/identification.svg";
import { useSelector, shallowEqual } from "react-redux";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/solid";

export function Header() {
  
  const eSyncApptCheck = window?.location?.href?.split('/esync_apt/');
  const eSyncApptID = eSyncApptCheck && eSyncApptCheck?.length > 1 ? eSyncApptCheck[1] : null;
  const { user, selectedPatient } = useSelector(
    ({ auth, providerNote }) => ({
      user: auth.user,
      selectedPatient: providerNote?.selectedPatient
    }),
    shallowEqual
  );
  return !eSyncApptID ? (
    <nav className="bg-black py-3 sticky top-0 z-50">
      <div className="lg:max-w-[95%] m-auto md:max-w-[95%] sm:max-w-[95%]">
        <div className="flex justify-between gap-4 items-center lg:gap-1 sm:gap-1">
          <div className="flex justify-between gap-12 items-center lg:gap-4 sm:gap-4">

            <Menu as="div" className="relative  text-left ">
              <div>
                <Menu.Button className="inline-flex items-center justify-center rounded-md border border-transparent  px-2 py-1  font-medium text-white  focus:outline-none ">
                  <a className="text-white">
                    <img src={IcMenu} alt="" />
                  </a>
                </Menu.Button>
              </div>
              <Transition as={Fragment}>
                <Menu.Items className="absolute z-20 mt-2 mt-4 h-52 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none 2xl:container1440 xl:container1440 lg:container1024 md:container1024 sm:container1024">
                  <div className="p-3 border ">


                  </div>
                </Menu.Items>
              </Transition>
            </Menu>



            <a className="logo cursor-pointer">
              <img src={icEthizo} alt="" />
            </a>
            <a className="logo">
              <img src={icScreen} alt="" />
            </a>

            {/*
            // commented for later use 
            <div className="searchBar flex gap-2 bg-white rounded p-1 items-center">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
              </svg>

              <input type="text" className="w-96 lg:w-80 focus:ring-0 focus-within:outline-0" placeholder="Search Patient" />
              <div className="2xl:flex xl:flex lg:hidden gap-1">
                <button className="py-2 px-4 bg-green-1 text-white font-normal rounded cursor-pointer hover:bg-success-hover">Add Patient</button>
                <button className="py-2 px-4 bg-green-1 text-white font-normal rounded cursor-pointer hover:bg-success-hover ">Import Patients</button>
                <button className="py-2 px-4 bg-green-1 text-white font-normal rounded cursor-pointer hover:bg-success-hover">Self Enrolments</button>
              </div>
              <Menu as="div" className="relative inline-block text-left xl:hidden 2xl:hidden lg:block">
                <div>
                  <Menu.Button className="inline-flex items-center justify-center rounded-md border border-transparent bg-green-1 px-2 py-1  font-medium text-white  focus:outline-none ">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                    </svg>


                  </Menu.Button>
                </div>

                <Transition as={Fragment}>
                  <Menu.Items className="absolute right-0 z-20 mt-2 w-44 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <div className="p-3 border rounded">
                      <Menu.Item>
                        <div className="py-2 px-4 bg-green-1 text-white font-normal rounded mb-2 cursor-pointer hover:bg-success-hover">
                          Add Patient
                        </div>
                      </Menu.Item>
                      <Menu.Item >
                        <div className="py-2 px-4 bg-green-1 text-white font-normal rounded mb-2 cursor-pointer hover:bg-success-hover">
                          Import Patients
                        </div>
                      </Menu.Item>
                      <Menu.Item >
                        <div className="py-2 px-4 bg-green-1 text-white font-normal rounded cursor-pointer hover:bg-success-hover">
                          Self Enrolments
                        </div>
                      </Menu.Item>

                    </div>
                  </Menu.Items>
                </Transition>
              </Menu>
            </div>
            <div>
              <ul className="flex ml-3 justify-between gap-12 items-center lg:gap-4 sm:gap-4">
                <li>

                  <Menu as="div" className="relative inline-block text-left ">
                    <div>
                      <Menu.Button className="inline-flex items-center justify-center rounded-md border border-transparent  px-2 py-1  font-medium text-white  focus:outline-none ">
                        <a className="flex gap-2 items-center text-white hover:underline">Practice sixty two
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-4 h-4">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                          </svg>

                        </a>

                      </Menu.Button>
                    </div>

                    <Transition as={Fragment}>
                      <Menu.Items className="absolute right-0 z-20 mt-2 w-52 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                        <div className="p-3 border rounded">
                          <Menu.Item>
                            <div className="py-2 px-4 bg-green-1 text-white font-normal rounded mb-2 cursor-pointer hover:bg-success-hover">
                              Practice sixty two
                            </div>
                          </Menu.Item>
                          <Menu.Item >
                            <div className="py-2 px-4 bg-green-1 text-white font-normal rounded mb-2 cursor-pointer hover:bg-success-hover">
                              Practice sixty three
                            </div>
                          </Menu.Item>
                          <Menu.Item >
                            <div className="py-2 px-4 bg-green-1 text-white font-normal rounded cursor-pointer hover:bg-success-hover">
                              Practice sixty four
                            </div>
                          </Menu.Item>

                        </div>
                      </Menu.Items>
                    </Transition>
                  </Menu>


                </li>

              </ul>
            </div> */}
          </div>

          <ul className="flex justify-between gap-12 items-center lg:gap-4 sm:gap-4">
            <li>

              <Menu as="div" className="relative inline-block  ">
                <div>
                  <Menu.Button className="inline-flex items-center justify-center rounded-md border border-transparent  px-2 py-1  font-medium text-white  focus:outline-none ">
                    <a className="flex gap-2 items-center cursor-default text-white hover:underline">{selectedPatient?.Patient?.practice_name ?
                      selectedPatient?.Patient?.practice_name
                      : ''}
                      <img src={icPractice} alt="" />
                      {/* 
                      // commented for later use
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-4 h-4">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                      </svg> */}

                    </a>

                  </Menu.Button>

                  <Menu.Button className="inline-flex items-center justify-center rounded-md border border-transparent  px-2 py-1  font-medium text-white  focus:outline-none ">
                    <a className="flex gap-2 items-center cursor-default text-white hover:underline">{user?.fname + ' ' + user?.lname}
                      <img src={icPlaceholder} alt="" />
                      {/* 
                      // commented for later use
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-4 h-4">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                      </svg> */}

                    </a>

                  </Menu.Button>
                </div>
                {/*
                // commented for later use 
                <Transition as={Fragment}>
                  <Menu.Items className="absolute right-0 z-20 mt-2 w-52 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <div className="p-3 border rounded">
                      <Menu.Item>
                        <div className="py-2 px-4 bg-green-1 text-white text-center font-normal rounded mb-2 cursor-pointer hover:bg-success-hover">
                          Profile
                        </div>
                      </Menu.Item>
                      <Menu.Item >
                        <div className="py-2 px-4 bg-green-1 text-center text-white font-normal rounded mb-2 cursor-pointer hover:bg-success-hover">
                          Logout
                        </div>
                      </Menu.Item>


                    </div>
                  </Menu.Items>
                </Transition> */}
              </Menu>

            </li>
          </ul>

        </div>
      </div>
    </nav>
  ) : ('');
}
